import { render, staticRenderFns } from "./navAdd.vue?vue&type=template&id=61026d10&scoped=true&"
import script from "./navAdd.vue?vue&type=script&lang=js&"
export * from "./navAdd.vue?vue&type=script&lang=js&"
import style0 from "./navAdd.vue?vue&type=style&index=0&id=61026d10&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61026d10",
  null
  
)

export default component.exports